import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { toast } from "react-hot-toast";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

export const useGetCondominioPossuiContaProvisionamentoAtiva = (condominioId: number | null) => {
  const onError = () => {
    toast.error("Erro ao verificar se condominio possui conta de provisionamento");
  };

  return useQuery<Cond21CloudResponse<boolean>>({
    queryKey: ["condominio-possui-conta-provisionamento-ativa-", condominioId],

    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<boolean>>(
        `${api.condominio.getCondominioPossuiContaProvisionamentoAtiva}/${condominioId}`
      );
      return response.data;
    },
    enabled: condominioId != null,
    onError,
  });
};
